export default [
  'ATHLETE_DROP_OFF_LOCATION',
  'BRING_TO_ME_LOCATION',
  'CURB_SIDE_PICKUP_LOCATION',
  'FITTING_ROOM_AREA',
  'HOLD_LOCATION',
  'LOCKERS',
];
